import { render, staticRenderFns } from "./PocketButton.vue?vue&type=template&id=3eadbc1c&scoped=true&"
import script from "./PocketButton.vue?vue&type=script&lang=js&"
export * from "./PocketButton.vue?vue&type=script&lang=js&"
import style0 from "./PocketButton.vue?vue&type=style&index=0&id=3eadbc1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eadbc1c",
  null
  
)

export default component.exports